import { renderValidatorMessage } from "../../actions/renderValidatorMessage";

export const ordersValidatorsColumns = (t: any) => [
  {
    key: "createdDate",
    name: t('validators.columns.createdDate'),
    fieldName: "createdDateStr",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: "message",
    name: t('validators.columns.message'),
    fieldName: "message",
    minWidth: 300,
    maxWidth: 350,
    isResizable: true,
    onRender: (item: any) => renderValidatorMessage(item, t),
  },
  {
    key: "Number",
    name: t('validators.columns.orderNumber'),
    fieldName: "Number",
    minWidth: 100,
    maxWidth: 180,
    isResizable: true,
  },
  {
    key: "CompanyName",
    name: t('validators.columns.client'),
    fieldName: "CompanyName",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "approvedDate",
    name: t('validators.columns.approvedDate'),
    fieldName: "approvedDateStr",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "comment",
    name: t('validators.columns.comment'),
    fieldName: "comment",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
];